export enum CommunicationViewTypes {
    Notification = 1,
    Message = 2
}